import type { GuideMeta, PlatformMode } from './types';

export interface FilterContext {
  can: (required?: string[]) => boolean;
  mode: PlatformMode;
}

const ALL_MODES: PlatformMode[] = ['full', 'api_as_service'];

export function filterGuides(
  guides: GuideMeta[],
  ctx: FilterContext
): GuideMeta[] {
  return guides.filter(
    (g) => ctx.can(g.permissions) && (g.modes ?? ALL_MODES).includes(ctx.mode)
  );
}
